import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Funcionalidade } from '../page/funcionalidade/funcionalidade';

@Injectable({ providedIn: 'root' })
export class FuncionalidadeService {

  private apiURL = environment.apiBaseUrl + 'funcionalidade';

  constructor(private http: HttpClient) { }

  listar(): Observable<Funcionalidade[]> {
    return this.http.get<Funcionalidade[]>(this.apiURL);
  }

  listarAtivas(segmentoId?: number | null): Observable<Funcionalidade[]> {
    let params = new HttpParams();
    if (segmentoId != null) {
      params = params.set('segmentoId', segmentoId.toString());
    }
    return this.http.get<Funcionalidade[]>(`${this.apiURL}/ativas`, { params });
  }

  buscarPorId(id: number): Observable<Funcionalidade> {
    return this.http.get<Funcionalidade>(`${this.apiURL}/${id}`);
  }

  salvar(funcionalidade: Funcionalidade): Observable<Funcionalidade> {
    if (funcionalidade.id) {
      return this.http.put<Funcionalidade>(`${this.apiURL}/${funcionalidade.id}`, funcionalidade);
    }
    return this.http.post<Funcionalidade>(this.apiURL, funcionalidade);
  }

  inativar(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiURL}/${id}`);
  }
}
